import React from 'react';
import { Frown, DollarSign, Zap, HelpCircle } from 'lucide-react';
export function PainSection() {
  const pains = [{
    icon: <Frown className="w-8 h-8 text-alphaGold" data-id="element-373" data-mp="38xerf3fro5n7" />,
    title: 'Entrenas duro y no ves resultados',
    desc: 'Horas en el gym, sudor, esfuerzo… y el espejo no muestra nada diferente. Sin la nutrición correcta, tu cuerpo no puede crecer sin importar cuánto entrenes.'
  }, {
    icon: <DollarSign className="w-8 h-8 text-alphaGold" data-id="element-374" data-mp="2l7kgirf0cr5l" />,
    title: 'Los suplementos importados cuestan una fortuna',
    desc: 'Pagas precios exorbitantes por marcas extranjeras con flete, impuestos y demoras. Mientras tanto, tu progreso espera. Ya no tiene por qué ser así.'
  }, {
    icon: <Zap className="w-8 h-8 text-alphaGold" data-id="element-375" data-mp="2ga129rib8edn" />,
    title: 'Te falta energía y recuperación',
    desc: 'Terminas el entrenamiento destruido, tardas días en recuperarte y perdés sesiones por cansancio. Tu cuerpo está pidiendo combustible de calidad, no aguante de voluntad.'
  }, {
    icon: <HelpCircle className="w-8 h-8 text-alphaGold" data-id="element-376" data-mp="3rlpopgmyledy" />,
    title: 'No sabés qué suplemento elegir',
    desc: 'El mercado está lleno de opciones y promesas vacías. El miedo a gastar mal el dinero te paraliza. Nosotros te guiamos al suplemento exacto para tu objetivo.'
  }];
  return <section className="bg-gradient-to-b from-dark-900 via-dark-700 to-dark-900 py-[80px] px-5" data-id="element-377" data-mp="i12m5765vev">
      <div className="max-w-[1100px] mx-auto" data-id="element-378" data-mp="38xkogj5igbjw">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-379" data-mp="38u6rjqfm8uju">
          ¿Te Sentís Identificado?
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-380" data-mp="3in4ce382yvlm">
          Si alguna de estas situaciones te pasa, tenemos la solución exacta que
          necesitás.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10" data-id="element-381" data-mp="2q501ficht0o0">
          {pains.map((pain, idx) => <div key={idx} className="bg-dark-600 border border-dark-300 border-l-4 border-l-alphaGold p-[30px_25px] rounded" data-id="element-382" data-mp="2l6f9s7bb3pb6" data-mpi={idx}>
              <div className="mb-4" data-id="element-383" data-mp="u23sca49yhwk">{pain.icon}</div>
              <h3 className="text-[1.1rem] font-bold mb-2.5 text-white" data-id="element-384" data-mp="u0k7e67obiog">
                {pain.title}
              </h3>
              <p className="text-[#999] leading-[1.7] text-[0.95rem]" data-id="element-385" data-mp="12uyw0ze3g5k8">
                {pain.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}